<template>
  <div class="card terminology-generic" style="box-shadow: none">
    <b-modal :active.sync="modal.formCreate" has-modal-card>
      <terminology-form-create @submit="onFormCreateSubmit" />
    </b-modal>
    <b-modal :active.sync="modal.formUpdate" has-modal-card>
      <terminology-form-update
        :terminology="terminologySelected"
        @submit="onFormUpdateSubmit"
      />
    </b-modal>
    <header class="card-header">
      <div class="card-header-title has-text-dark is-size-4">Generic</div>
      <div class="buttons">
        <b-button
          type="is-primary"
          :disabled="!isSuperadmin"
          @click="modal.formCreate = true"
        >
          ADD
        </b-button>
      </div>
    </header>
    <div class="card-content scrollable">
      <base-table
        :service="$options.terminologyService"
        fetch-func="all"
        :fetch-params="{ type: 'generic' }"
        :columns="$options.columns"
        ref="table"
      >
        <template #rowActions="{ row }">
          <b-button
            type="is-link"
            :disabled="!isSuperadmin"
            @click="onTableEdit(row)"
          >
            EDIT
          </b-button>
        </template>
      </base-table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BaseTable from "@/components/partials/BaseTable";
import TerminologyFormCreate from "@/components/Terminology/TerminologyFormCreate";
import TerminologyFormUpdate from "@/components/Terminology/TerminologyFormUpdate";
import { TerminologyService } from "@/services/terminology.service";

export default {
  terminologyService: TerminologyService,
  columns: [
    {
      field: "key",
      label: "Key"
    },
    {
      field: "value",
      label: "Value"
    },
    {
      field: "actions",
      label: "",
      numeric: true,
      meta: {
        rowSlot: "rowActions"
      }
    }
  ],
  components: {
    BaseTable,
    TerminologyFormCreate,
    TerminologyFormUpdate
  },
  data: () => ({
    modal: {
      formCreate: false,
      formUpdate: false
    },
    terminologySelected: null
  }),
  computed: {
    isSuperadmin() {
      return this.$store.getters["Auth/hasRole"]("superadmin");
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      return this.$refs.table.fetchData();
    },
    onTableEdit(terminology) {
      this.terminologySelected = terminology;
      this.modal.formUpdate = true;
    },
    onFormCreateSubmit(terminology) {
      this.fetch();
      this.$emit("created", terminology);
    },
    onFormUpdateSubmit(terminology) {
      this.fetch();
      this.$emit("updated", terminology);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Terminology/TerminologyTableGeneric.vue